





































































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import Import from "./import.vue";
import EditResourcePage from "./edit-resource.vue";
import {
  UploadFile,
  GetKnowledgeWendaList,
  GetChapterResource,
  ChapterConnectResource,
  ChapterAddResource,
  CancelConnectResource,
  EditResource,
} from "@/request/common";
import Empty from "@/components/empty.vue";
import QaCell from "@/components/qa/qa-cell.vue";
@Component({
  components: {
    Import,
    EditResourcePage,
    Empty,
    QaCell,
  },
})
export default class Name extends Vue {
  @Prop()
  private type: any;
  @Watch("type", { immediate: true })
  private typeChange() {
    if (this.id) {
      this.getData();
    }
  }
  @Prop()
  private id: any;
  @Watch("id", { immediate: true })
  private idChange() {
    if (this.id) {
      this.getData();
    }
  }
  private qaTab: any = "全部问题";
  private data: any = [];
  private ifShowImport: any = false;
  private ifShowEditImg: any = false;
  private editImgData: any = {
    file_list: [],
  };
  private wendaData: any = {};
  private get user() {
    return this.$store.state.user;
  }
  private get systemInfo() {
    return this.$store.state.systemInfo;
  }
  private changeZhishidian(e: any) {
    this.cancelImport();
    this.$emit("changeZhishidian", e);
  }
  private changeQaTab(val: any) {
    this.qaTab = val;
    this.getData();
  }
  private preview(url: any) {
    window.open(url);
  }
  private editSure(e: any) {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    e["类别"] = this.type;
    if (e.ziyuan_id) {
      if (!e["类别"]) {
        e["类别"] = this.type;
      }
      EditResource(this, e, loading)
        .then((res: any) => {
          loading.close();
          this.ifShowEditImg = false;
          this.$message.success(`${e.ziyuan_id ? "编辑" : "添加"}` + "成功");
          this.getData();
        })
        .catch(() => {
          loading.close();
        });
    } else {
      const obj = {
        url: e.file_list,
        name: e["名称"],
        类别: this.type,
        chapter_id: this.id,
        简介: e["简介"],
      };
      ChapterAddResource(this, obj, loading)
        .then((res: any) => {
          loading.close();
          this.$message.success("上传成功");
          this.getData();
          this.ifShowEditImg = false;
        })
        .catch(() => {
          loading.close();
        });
    }
  }
  private select(d: any) {
    if (d.length == 0) {
      this.ifShowImport = false;
      return;
    }
    let ids: any = [];
    d.forEach((ele: any) => {
      ids.push(ele.ziyuan_id);
    });
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params: any = {
      chapter_id: this.id,
      ziyuan_ids: ids,
    };
    ChapterConnectResource(this, params, loading)
      .then((res: any) => {
        loading.close();
        this.$message.success("导入成功");
        this.getData();
        this.ifShowImport = false;
      })
      .catch(() => {
        loading.close();
      });
  }
  private openEditImg(item: any) {
    if (item) {
      this.editImgData = JSON.parse(JSON.stringify(item));
      this.ifShowEditImg = true;
    } else {
      this.editImgData = {
        file_list: [],
      };
      this.ifShowEditImg = true;
    }
  }
  private xiazai(url: any) {
    window.open(url);
  }
  private openImport() {
    this.ifShowImport = true;
  }
  private changeTab(item: any) {
    this.$emit("change", item);
    setTimeout(() => {
      this.getData();
    }, 200);
  }
  private cancelImport() {
    this.ifShowImport = false;
  }
  private upload(file: any) {
    const fileObj = file.file;
    // FormData 对象
    const form = new FormData();
    // 文件对象
    form.append("type", "file");
    form.append("file", fileObj);
    const loading1 = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    UploadFile(this, form, loading1)
      .then((res: any) => {
        loading1.close();
        const obj: any = {
          url: res.full_file_url,
          name: file.file.name,
          类别: this.type,
          chapter_id: this.id,
        };
        const loading = this.$loading({
          lock: true,
          text: "加载中……",
          spinner: "el-icon-loading",
          customClass: "loadClass",
          background: "rgba(255, 255, 255, 0.7)",
        });
        ChapterAddResource(this, obj, loading)
          .then((res: any) => {
            loading.close();
            this.$message.success("上传成功");
            this.getData();
          })
          .catch(() => {
            loading.close();
          });
      })
      .catch(() => {
        loading1.close();
      });
  }
  private delKejian(item: any) {
    this.$confirm("确定要删除吗？", "删除", {
      customClass: "commonConfirm",
      confirmButtonClass: "iconfont icon-anniu4 confirmSure",
      cancelButtonClass: "iconfont icon-anniu3 confirmCancel",
    }).then(() => {
      const loading = this.$loading({
        lock: true,
        text: "加载中……",
        spinner: "el-icon-loading",
        customClass: "loadClass",
        background: "rgba(255, 255, 255, 0.7)",
      });
      const params: any = {
        data: {
          chapter_id: this.id,
          ziyuan_ids: [item.ziyuan_id],
        },
      };
      CancelConnectResource(this, params, loading)
        .then((res: any) => {
          loading.close();
          this.getData();
        })
        .catch(() => {
          loading.close();
        });
    });
  }
  private getData() {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    if (this.type == "问答") {
      const params: any = {
        params: {
          chapter_id: this.id,
          banji_id: this.user["所属班级"].banji_id,
          状态: this.qaTab == "全部" ? "" : this.qaTab,
        },
      };
      GetKnowledgeWendaList(this, params, loading)
        .then((res: any) => {
          loading.close();
          this.data = res;
        })
        .catch(() => {
          loading.close();
        });
    } else {
      const params: any = {
        params: {
          chapter_id: this.id,
          类别: this.type,
        },
      };
      GetChapterResource(this, params, loading)
        .then((res: any) => {
          loading.close();
          this.data = res;
        })
        .catch(() => {
          loading.close();
        });
    }
  }
}
